module.exports = {
  email: 'oyerohabib@yahoo.com',

  resumeUrl: 'https://calendly.com/oyerohabib2305/free-30-minute-consultation',
  whatsappNumber: '+2347019951241',
  whatsappUrl: 'https://wa.me/2347019951241',
  googleAnalyticsId: 'G-S8GVRBTK7M',

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/oyerohabib',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/Habiboyero',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/oyerohabib/',
    },
    {
      name: 'WhatsApp',
      url: 'https://wa.me/2347019951241',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Work',
      url: '/#projects',
    },
    {
      name: 'Recommendations',
      url: '/#recommendations',
    },
    {
      name: 'Certifications',
      url: '/certifications',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 0, viewFactor) => {
    const rawDelay = Number.isFinite(delay) ? delay : 0;
    const safeDelay = Math.max(0, Math.min(rawDelay, 150));
    const isSmallScreen =
      typeof window !== 'undefined' && window.matchMedia('(max-width: 1080px)').matches;
    let safeViewFactor = isSmallScreen ? 0.1 : 0.2;
    if (Number.isFinite(viewFactor)) {
      safeViewFactor = Math.max(0, Math.min(viewFactor, 1));
    }

    return {
      origin: 'bottom',
      distance: isSmallScreen ? '10px' : '14px',
      duration: isSmallScreen ? 300 : 380,
      delay: safeDelay,
      rotate: { x: 0, y: 0, z: 0 },
      opacity: 0,
      scale: 1,
      easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
      mobile: true,
      reset: false,
      useDelay: 'once',
      viewFactor: safeViewFactor,
      viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
    };
  },
};
